import React, { Component } from "react";
import Global from "../../../Global";
import "./SpecialSelectSection.css";
import SectionLabel from "../../common/SectionLabel";
import LinkButton from "../../common/LinkButton";
import SpecialSelectBanners from "./SpecialSelectBanners";

class SpecialSelectSection extends Component {
  constructor(props) {
    super(props);

    this.state = {
      linkButtons: null,
      banners: null,
    };
  }

  componentWillMount() {
    const url = Global.getAPI("home-special-select-section");
    let self = this;
    fetch(url)
      .then(function(response) {
        if (response.status >= 400) {
          throw new Error("Error API: home-special-select-section");
        }
        return response.json();
      })
      .then(function(data) {
        const { linkButtons, banners } = data;
        self.setState({
          linkButtons,
          banners,
        });
      });
  }

  render() {
    const lang = window.THREE_REACT_APP_GLOBAL.language;
    const sectionLabel = lang === "tc" ? "3至你賞" : "3Select";

    const { linkButtons, banners } = this.state;

    return (
      <section className="section-special-select" id="section-special-select">
        <div className="section-special-select-container container">
          <div className="section-special-select-header-container">
            <SectionLabel
              className="section-special-select-label"
              text={sectionLabel}
            />

            {linkButtons !== null && linkButtons.length > 0 && (
              <div className="link-button-group-container">
                {linkButtons.map((linkButton, i) => (
                  <LinkButton
                    key={`link-button-${i + 1}`}
                    linkButton={linkButton}
                  />
                ))}
              </div>
            )}
          </div>

          <SpecialSelectBanners banners={banners} />
        </div>
      </section>
    );
  }
}

export default SpecialSelectSection;
